module.exports = __webpack_public_path__ + "static/media/play_icon_small.442a5376.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/play_icon_small.svg
// module id = 542
// module chunks = 8